<!--
 * @Author: 孙照
 * @LastEditTime: 2023-02-16 16:08:03
 * @Description: 折线图组件
 * @FilePath: \fuzhou\src\components\pubLineChart\index.vue
-->
<template>
  <div class="pub-line-chart"></div>
</template>
<script>

import * as Echarts from 'echarts';
import { merge } from 'lodash';
import ResizeListener from 'element-resize-detector';
import { basicOption } from './defaultOption';

export default {
  name: 'pubLineChart',
  props: {
    // 双y轴控制
    twoSeries: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 横坐标轴数据
    xAxisData: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 纵坐标轴数据
    seriesData: {
      type: Array,
      required: true,
    },
    // 纵坐标轴数据2
    seriesData2: {
      type: Array,
      require: false,
    },
    // 额外配置数据，用于灵活添加配置项
    extraOption: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    seriesData: {
      deep: true,
      handler() {
        this.updateChartView();
      },
    },
    seriesData2: {
      deep: true,
      handler() {
        this.updateChartView();
      },
    },
    extraOption: {
      deep: true,
      handler() {
        this.updateChartView();
      },
    },
  },

  mounted() {
    this.lineChartsInit();
    this.updateChartView();
    window.addEventListener('resize', this.handleWindowResize);
    this.addChartResizeListener();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  },
  methods: {
    lineChartsInit() {
      this.chart = Echarts.init(this.$el);
    },
    // 合并 options
    assembleDataToOption() {
      if (!this.seriesData.length) {
        this.option = {
          title: {
            text: '暂无数据',
            x: 'center',
            y: 'center',
            textStyle: {
              fontSize: this.fitChartSize(24),
              fontWeight: 'normal',
              color: '#fff',
            },
          },
        };
        return this.option;
      }
      const seriesData = this.twoSeries
        ? [{ data: this.seriesData }, { data: this.seriesData2 }]
        : [{ data: this.seriesData }];
      return merge(
        {},
        basicOption,
        {
          xAxis: { data: this.xAxisData },
          series: seriesData,
        },
        this.extraOption,
      );
    },
    // 对chart元素尺寸进行监听，当发生变化时同步更新echart视图
    addChartResizeListener() {
      const instance = ResizeListener({
        strategy: 'scroll',
        callOnAdd: true,
      });

      instance.listenTo(this.$el, () => {
        if (!this.chart) return;
        this.chart.resize();
      });
    },

    // 更新echart视图
    updateChartView() {
      if (!this.chart) return;
      const fullOption = this.assembleDataToOption();
      this.chart.setOption(fullOption, true);
    },
    // 窗口缩放，echart 动态调整大小
    handleWindowResize() {
      if (!this.chart) return;
      this.chart.resize();
    },

  },
};
</script>

<style lang="less" scoped>
  .pub-line-chart {
    width: 100%;
    height: 100%;
  }
</style>
